export default __webpack_public_path__ + "static/media/hero-insiemeMedium.5e971e34.jpg";